import { lazy } from 'react';

import { retryDynamicImport } from './retryDynamicImport';

/**
 * `React.lazy` for local route chunks that forces a one-time page reload when a
 * stale client fails to fetch a chunk after a deploy. See `retryDynamicImport`.
 */
export const lazyWithReload: typeof lazy = (importFn) =>
  lazy(retryDynamicImport(importFn));
